module.exports = __webpack_public_path__ + "files/244db27f9e25edd519486604c233902f.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Caligraphic-Regular.ttf
// module id = 1415
// module chunks = 59